import * as React from "react";
import {
  App,
  Panel,
  View,
  Statusbar,
  Popup,
  Page,
  Navbar,
  NavRight,
  Link,
  Block,
  // LoginScreen,
  // LoginScreenTitle,
  // List,
  // ListItem,
  // Label,
  // Input,
  // ListButton,
  // BlockFooter,
} from "framework7-react";

import routes from "../routes";
import { getToken } from "src/utils/utils";
import LoginPage from "./pages/LoginPage";

export default () => {
  // const store = Framework7.createStore({
  //   state: {},
  //   actions: {},
  //   getters: {},
  // });

  // console.log("STORE", store);

  // Framework7 parameters here
  const f7params = {
    id: "aduana.inkprimelo.com", // App bundle ID
    name: "Inkprimelo", // App name
    theme: "md", // Automatic theme detection
    panel: {
      swipe: true,
      visibleBreakpoint: 0,
      leftBreakpoint: 0,
    },
    dialog: {
      title: "Inkprimelo",
    },
    store: { users: [] },
    // App routes
    routes,
  };

  const token = getToken();
  console.log("token", token);
  return (
    <App params={f7params}>
      <Statusbar />

      <Panel left>
        <View url="/panel-left/" linksView=".view-main" />
      </Panel>

      <Panel right reveal themeDark>
        <View url="/panel-right/" />
      </Panel>

      <View
        id="main-view"
        url="/"
        main
        animate={false}
        className="safe-areas"
        pushState={true}
      />

      <Popup id="popup">
        <View>
          <Page>
            <Navbar title="Popup">
              <NavRight>
                <Link popupClose>Close</Link>
              </NavRight>
            </Navbar>
            <Block>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Neque,
              architecto. Cupiditate laudantium rem nesciunt numquam, ipsam.
              Voluptates omnis, a inventore atque ratione aliquam. Omnis iusto
              nemo quos ullam obcaecati, quod.
            </Block>
          </Page>
        </View>
      </Popup>

      <LoginPage />
    </App>
  );
};



// WEBPACK FOOTER //
// ./src/components/App.tsx